// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__pWMMi","input":"Checkbox_input__3CIfT","box":"Checkbox_box__hmqkw","active":"Checkbox_active__8W2Xv"};